module.exports = __webpack_public_path__ + "static/img/taxcellent_tp_bg_h5.fd2d543.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/publicDetail/taxcellent_tp_bg_h5.png
// module id = eYYk
// module chunks = 34